import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTiktok = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <rect
      width={32}
      height={32}
      fill="#F18700"
      rx={16}
    />
    <path
      fill="#fff"
      d="M16.392 7.013C17.269 7 18.14 7.007 19.012 7c.053 1.025.422 2.07 1.172 2.794.75.744 1.809 1.085 2.84 1.2v2.7c-.964-.034-1.936-.235-2.813-.65a8 8 0 0 1-1.086-.624c-.006 1.957.007 3.913-.013 5.863a5.1 5.1 0 0 1-.905 2.64c-.877 1.286-2.398 2.124-3.96 2.15-.957.054-1.915-.207-2.733-.69-1.353-.797-2.305-2.258-2.445-3.825-.014-.335-.02-.67-.007-.999a5.03 5.03 0 0 1 1.729-3.323c1.112-.965 2.666-1.427 4.12-1.152.013.991-.027 1.983-.027 2.974-.663-.214-1.44-.154-2.023.248a2.33 2.33 0 0 0-.911 1.173c-.141.342-.1.717-.094 1.079.16 1.098 1.22 2.023 2.345 1.922.75-.006 1.467-.442 1.856-1.078.127-.221.268-.45.274-.71.067-1.2.04-2.392.047-3.592.007-2.7-.006-5.393.014-8.087"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgTiktok);

export default ForwardRef;
